import React, { useCallback, useState, useMemo, useEffect } from "react";
import cls from './style.module.scss';
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../../../../../components/icon/iconfont";
import { OrderPackageItem } from "../../../fragments/order-package";
import { BigButton } from "../../../../../../../../components/button";
import ReturnOrderLayout from "../components/layout";
import Toast from "../../../../../../../../components/toast";
import NormalConfigConfirm from "../../../../../../../../components/alert/config-confirm";
import { useHistory } from "react-router-dom";
import { useIntl, FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { action_fetch_order_list_return } from "../../../../../../../../../store/actions/pages/customer";
import { fetchGetMessage } from "../../../../../../../../../api";
import { uniqBy } from 'lodash';


const CannotReturn = props =>{
    const { unReturnList, setShowUnList, setReturnList } = props;
    const Intl = useIntl();
    const [message, setMessage] = useState(null);

    useEffect(async () =>{
        let response = await fetchGetMessage("M1808");
        if(response?.code === 200 && response?.result?.message){
            let message = response.result.message.replace(/\\n/g, '<br />');
            setMessage(message);
        }
    }, []);

    const actualFont = useCallback((size) =>{
        return `${2 * size / 75 * 1}rem`;
    }, []);

    const handleQuestion = useCallback((list) =>{
        if(!!message){
            NormalConfigConfirm({
                boxStyle: {
                    padding: `${actualFont(20)} ${actualFont(14)} ${actualFont(14)}`,
                },
                message:{
                    text: message,
                    html: true,
                    style: {
                        fontFamily: 'Roboto-Bold',
                        lineHeight: actualFont(16),
                        textAlign: 'left',
                        marginBottom: actualFont(20)
                    }
                },
                btn1:{
                    text: Intl.formatMessage({ id: "require_support", defaultMessage: "Require Support" }),
                    style: {
                        border: `1px solid #222`,
                        color: '#222',
                        backgroundColor: 'transparent'
                    },
                    clickHandle:()=>{
                        const disposeList = list.map(item=>({ ...item, returnStatus: 1 }));
                        setShowUnList(false);
                        setReturnList(state=>[ ...state, ...disposeList ]);
                    }
                },
                btn2:{
                    text: Intl.formatMessage({ id: "confirm", defaultMessage: "confirm" }),
                    style: {
                        border: 'none',
                        backgroundColor: '#222',
                        color: '#fff'
                    },
                }
            });
        }
    }, [message]);

    return <React.Fragment>
        <div className={`${cls.CannotReturn} ${cls.Special}`}>
            <div className={cls.Font}>
                <span className={cls.FontMess}><FormattedMessage id="cannot_be_returned" defaultMessage="This kind of item cannot be returned" /></span>&nbsp;
                <span className={cls.Question} onClick={()=>handleQuestion(unReturnList)}>?</span>
            </div>
        </div>

        {
            unReturnList.map((product, index)=>(
                <OrderPackageItem key={index+product?.variantId} product={product} style={{ color: '#999999', borderTop: "none" }} isReturn />
            ))
        }
    </React.Fragment>
}

const AlreadyReturn = props =>{
    const { alReadyReturnList, onClose, isApp, orderId } = props;
    const history = useHistory();
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const dispatch = useDispatch();

    const handleClick = useCallback((e) =>{
        e.preventDefault();

        const haveReturn = alReadyReturnList.filter(item=>item.returnOrderId);
        const haveReturnList = uniqBy(haveReturn, "returnOrderId");

        if(haveReturnList?.length > 0){
            if(haveReturnList.length === 1){
                const returnId = haveReturnList[0].returnOrderId;
                if(isApp){
                    window.location.href = `chic-me://chic.me/returnOrderDetail?returnOrderId=${returnId}&orderId=${orderId}`;
                    return;
                }else{
                    history.push(`/user/order/return-detail/${returnId}`);
                }
            }else{
                if(isApp){
                    window.location.href = 'chic-me://chic.me/orderhistory?pageIndex=5';
                    return;
                }else{
                    if(pageCustomer?.orderListReturn?.data?.length > 0){
                        dispatch(action_fetch_order_list_return(true));
                    }
                    history.push(`/user/order/return`);
                }
            }
            onClose();
        }else{
            // 没有退货条目的时候关闭当前弹窗 tiekct页面需要做特殊处理
            onClose('ticket');
        }
    }, [alReadyReturnList, pageCustomer?.orderListReturn, isApp, orderId]);

    return <React.Fragment>
        <div className={cls.CannotReturn}>
            <div className={cls.Font}>
                <span><FormattedMessage id="are_being_returned" defaultMessage="Item(s) are being returned" /></span>
            </div>

            <a className={cls.View} onClick={handleClick}><FormattedMessage id="view" defaultMessage="view" /> {'>'}</a>
        </div>

        {
            alReadyReturnList.map((product, index)=>(
                <div className={cls.ReturnProduct} key={index+product?.variantId} style={{ borderTop: "none" }}>
                    <Iconfont className={`${cls.SelectLabel} ${cls.Active} ${cls.Disbaled}`}>&#xe65a;</Iconfont>

                    <OrderPackageItem product={product} style={{ borderTop: "none", padding: 0 }} isReturn showStatusView />
                </div>
            ))
        }
    </React.Fragment>
}

const  ReturnOrderSelect = props =>{
    useStyles(cls);
    const { returnList, setType, updateReturnList, setReturnList, onClose, reasonList, unReturnList, alReadyReturnList, isApp, orderId } = props;
    const [showUnList, setShowUnList] = useState(true);
    const Intl = useIntl();

    const handleSubmit = useCallback((list) =>{
        let dataArr = list.filter(item=>item.isActive);
        if(dataArr.length > 0 && !!reasonList){
            setReturnList(dataArr);
            setType(1);
        } else{
            Toast(Intl.formatMessage({ id: "select_to_be_returned", defaultMessage: "Please select the item(s) to be returned" }));
        }
    }, [reasonList]);

    return <ReturnOrderLayout 
        topSlot={<span><FormattedMessage id="please_select_the_items" defaultMessage="Please select the item(s)" /></span>} 
        bottomSlot={<BigButton onClick={()=>handleSubmit(returnList)}><FormattedMessage id="next" defaultMessage="next" /></BigButton>} 
        onClose={onClose} 
    >
        {
            returnList?.map((product, index)=>(
                <div className={cls.ReturnProduct} key={index+product?.variantId}>
                    <Iconfont className={`${cls.SelectLabel} ${product.isActive ? cls.Active : ""}`} onClick={()=>updateReturnList({ ...product, isActive: !product.isActive })}>&#xe65a;</Iconfont>

                    <OrderPackageItem product={product} style={{ borderTop: "none", padding: 0 }} isReturn />
                </div>
            ))
        }

        {
            alReadyReturnList?.length > 0 && <AlreadyReturn alReadyReturnList={alReadyReturnList} onClose={onClose} orderId={orderId} isApp={isApp} />
        }

        {
            showUnList && unReturnList?.length > 0 && <CannotReturn unReturnList={unReturnList} setShowUnList={setShowUnList} setReturnList={setReturnList}  />
        }
    </ReturnOrderLayout>
}

export default ReturnOrderSelect;